export const onCreateMosaicProdTable = `subscription OnCreateMosaicProdTable($group: String) {
    onCreateMosaicProdTable(group : $group) {
        group
        path
        type
    	roi
    	points
    }
}
`;
